import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-parts-pricing-dialog',
  templateUrl: './parts-pricing-dialog.component.html',
  styleUrls: ['./parts-pricing-dialog.component.scss']
})
export class PartsPricingDialogComponent implements OnInit {

  isOpenAsDialog: boolean = false;
  selectedMatrix:any = {};
  isReadOnly: boolean = false;
  constructor(
    private dynamicDialogRef: DynamicDialogRef,
    private dynamicDialogConfig: DynamicDialogConfig,) { }

  ngOnInit(): void {
    const { isOpenAsDialog, selectedMatrix, isReadOnly } = this.dynamicDialogConfig.data;
    this.isOpenAsDialog = isOpenAsDialog;
    this.selectedMatrix = selectedMatrix;
    this.isReadOnly = isReadOnly;
  }

  closeDialog(type) {
    this.dynamicDialogRef?.close();
  }

  onMatrixChange(matrix) {
    if (matrix.isCancel) this.closeDialog('');
    else {
      this.selectedMatrix = matrix;
      this.save();
    }
  }

  save() {
    this.dynamicDialogRef.close({ isSuccess: true, data: this.selectedMatrix.data, isPricing: this.selectedMatrix?.isNewPricingAdded });
  }
}
